import { render, staticRenderFns } from "./Downtime.vue?vue&type=template&id=651be907&"
import script from "./Downtime.vue?vue&type=script&lang=js&"
export * from "./Downtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports